export default {
    methods: {
        isImage(file) {
            return (file.extension === 'jpg' || file.extension === 'png' || file.extension === 'jpeg')
        },

        isAudio(file) {
            return !!file.song;
        },

        isVideo(file) {
            return (file.mime_type.indexOf('video') !== -1)
        },
    }
}
